


import React from 'react';
import Navigation from './Navigation';
import PropTypes from 'prop-types';

const Header = (props) => {
	return (
		<div className="c-site-header">
			<div className="l-content-width">
				<h2>Header</h2>
				<Navigation userDetails={props.userDetails} history={props.history} logOut={props.logOut} updateState={props.updateState} />
			</div>
		</div>
	);
}

Header.contextTypes = {
	router: PropTypes.object
}

export default Header;